if (!window.Eurus.loadedScript.has('scrolling-promotion.js')) {
  window.Eurus.loadedScript.add('scrolling-promotion.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xScrollPromotion', {
        animationFrameId: null,
        window_height: window.innerHeight,
        carousels: {},

        load(el) {
          let scroll = el.getElementsByClassName('el_animate');
          for (let i = 0; i < scroll.length; i++) {
            scroll[i].classList.add('animate-scroll-banner');
          }
        },

        initCarousel(el, sectionId, pauseDuration, transitionSpeed) {
          const container = el.querySelector('.carousel-container-' + sectionId);
          if (!container) {
            console.error('Carousel container not found for section:', sectionId);
            return;
          }

          const overflowContainer = container.parentElement;
          // Use window.innerWidth for accurate viewport width on mobile
          const viewportWidth = window.innerWidth;

          const firstElementDiv = container.querySelector('.element-' + sectionId);
          if (!firstElementDiv) {
            console.error('First element div not found');
            return;
          }

          // Get all individual blocks (icons, images, text, buttons)
          const allBlocks = Array.from(firstElementDiv.querySelectorAll('.space-blocks-' + sectionId));
          if (allBlocks.length === 0) {
            console.error('No blocks found');
            return;
          }

          let currentIndex = 0;
          let intervalId = null;
          const totalSlides = allBlocks.length;
          let blockOffsets = [];

          // Calculate centered offsets for each block
          const calculateOffsets = () => {
            blockOffsets = [];
            let cumulativeOffset = 0;
            const currentViewportWidth = window.innerWidth;

            allBlocks.forEach((block) => {
              // Get the actual content width (offsetWidth includes the 100vw padding)
              const fullWidth = block.offsetWidth;
              // Subtract viewport width to get actual content width (since padding is 100vw)
              const contentWidth = fullWidth - currentViewportWidth;

              // Center the content: position + (contentWidth / 2) should equal viewportWidth / 2
              // So translate = -(position + contentWidth/2 - viewportWidth/2)
              const blockCenter = cumulativeOffset + (contentWidth / 2);
              const centeredOffset = blockCenter - (currentViewportWidth / 2);

              blockOffsets.push(centeredOffset);
              cumulativeOffset += fullWidth;
            });
          };

          const moveToNext = () => {
            currentIndex++;

            // Loop back to start
            if (currentIndex >= totalSlides) {
              currentIndex = 0;
            }

            // Get the centered offset for the current block
            const offset = -blockOffsets[currentIndex];
            container.style.transition = `transform ${transitionSpeed}s ease-in-out`;
            container.style.transform = `translateX(${offset}px)`;
          };

          // Calculate and position immediately for first image
          calculateOffsets();
          container.style.transform = `translateX(${-blockOffsets[0]}px)`;

          // Recalculate after layout settles to ensure accuracy on mobile
          setTimeout(() => {
            calculateOffsets();
            container.style.transition = 'none';
            container.style.transform = `translateX(${-blockOffsets[0]}px)`;
            setTimeout(() => {
              container.style.transition = `transform ${transitionSpeed}s ease-in-out`;
            }, 50);
          }, 150);

          // Start carousel after initial positioning
          setTimeout(() => {
            intervalId = setInterval(moveToNext, pauseDuration * 1000);
          }, 150);

          // Pause on hover
          el.addEventListener('mouseenter', () => {
            if (intervalId) {
              clearInterval(intervalId);
              intervalId = null;
            }
          });

          el.addEventListener('mouseleave', () => {
            if (!intervalId) {
              intervalId = setInterval(moveToNext, pauseDuration * 1000);
            }
          });

          // Handle window resize for mobile orientation changes
          const handleResize = () => {
            calculateOffsets();
            // Update to current position with new calculations
            const offset = -blockOffsets[currentIndex];
            container.style.transition = 'none';
            container.style.transform = `translateX(${offset}px)`;
            setTimeout(() => {
              container.style.transition = `transform ${transitionSpeed}s ease-in-out`;
            }, 50);
          };

          let resizeTimeout;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(handleResize, 100);
          });

          // Store reference for cleanup
          this.carousels[sectionId] = {
            intervalId,
            container,
            el,
            handleResize
          };
        },

        createObserver(el, rtlCheck = false) {
          const option = {
            root: null,
            rootMargin: '300px',
            threshold: 0
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.updateRotation(el, rtlCheck)
              } else {
                if (this.animationFrameId) {
                  cancelAnimationFrame(this.animationFrameId);
                  this.animationFrameId = null;
                }
              }
            });
          }, option);

          observer.observe(el);
        },

        updateRotation(el, rtlCheck = false) {
          const update = () => {
            const element = el.firstElementChild;
            if (!element) return;

            const element_rect = element.getBoundingClientRect();
            const element_height = element_rect.top + element_rect.height / 2;
            let value;
              
            if (element_height > -200 && element_height < this.window_height + 200) {
              value = Math.max(Math.min((((element_height / this.window_height) * 10) - 5), 5), -5);
              if (rtlCheck) value *= -1;
              element.style.transform = `rotate(${value}deg) translateX(-20px)`;
            }

            this.animationFrameId = window.requestAnimationFrame(update);
          }

          if (!this.animationFrameId) {
            update();
          }
        },
      });
    })
  });
}    